/**
 * For safety to get window in server side
 */
export function useWindow() {
  if (typeof window === "undefined") return;
  return window;
}